import { useState, useEffect } from 'react';
import Util from "../../Service/util";
import Service from "../../Service/http";
import { FadeLoader } from "react-spinners";
import { useNavigate } from 'react-router-dom'
import SearchIcon from '@mui/icons-material/Search';
import UploadOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

function UploadVQR() {
    let [loading, setLoading] = useState(false);
    const service = new Service();
    const util = new Util();
    const navigate = useNavigate()
    useEffect(() => {
        let isLogin = util.loggedIn();
        let admin = util.isAdmin();
        if (!isLogin && window.location.pathname !== "/login" || !admin) {
            window.location.replace("/login");
        }
       

    }, []);

 

    return (
        <>
            {
                loading
                    ? <div style={{ marginTop: "10vh", marginRight:"10vh",textAlign:"center"}}><FadeLoader  margin={5} color="green" /></div>
                    :
                    <div className='card' style={{ "marginTop": "5%", marginLeft: "2%", marginRight: "2%" }}>
                        <h1 className='text-center card-title text-primary' style={{ "margin": "2%" }}>Mentee Options</h1>
                        <div>
                            <div className=" text-center card-body w-100 m-2">
                            <div className='d-flex justify-content-center w-100 m-2'>
                                <div className="list-group w-50 ">
                                    <a style={{ "cursor": "pointer",minWidth:"220px" }} onClick={() => navigate('/admin/mentees/list')} className="list-group-item list-group-item-action "><SearchIcon fontSize='large'></SearchIcon> Mentee List Search</a>
                                    <a style={{ "cursor": "pointer" ,minWidth:"220px"}} onClick={() => navigate('/admin/mentees/upload')} className="list-group-item list-group-item-action "><UploadOutlinedIcon fontSize='large'></UploadOutlinedIcon> Bulk Upload/Update</a>
                                    <a style={{ "cursor": "pointer",minWidth:"220px" }} onClick={() => navigate('/admin/mentees/delete')} className="list-group-item list-group-item-action "><DeleteOutlineIcon fontSize='large'></DeleteOutlineIcon> Bulk Delete</a>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}

export default UploadVQR;